<template>
  <v-row class="fill-height">
    <v-col cols="12" lg="6"
           :class="!$store.getters.GET_USER.role.includes('admin') ? 'align-center pa-lg-12' : ''"
           class="d-flex justify-center fill-height">
      <validation-observer ref="observer" class="nitg__width-100" v-slot="{ passes }">
        <v-form @submit.prevent="passes( submit )" class="nitg__width-100">
          <v-card tile flat color="#fff">
            <template v-slot:progress>
              <v-progress-linear
                  height="5"
                  :value="progress"
                  color="primary"
              ></v-progress-linear>
            </template>
            <v-card-title>{{ $t('ticketForm.title') }}</v-card-title>
            <v-card-subtitle>{{ $t('ticketForm.subtitle') }}</v-card-subtitle>
            <v-card-text>
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="pl-0 pr-0">
                  <validation-provider rules="required" :name="$t('ticketForm.requestSubject.name')" v-slot="{ errors }">
                    <v-select dense
                              v-model="form.type"
                              :placeholder="$t('ticketForm.requestSubject.placeholder')"
                              :label="$t('ticketForm.requestSubject.label')"
                              :error-messages="errors"
                              :items="$t('ticketForm.requestType')"></v-select>
                  </validation-provider>
                </v-col>
                <v-col cols="12" class="pl-0 pr-0">
                  <validation-provider rules="required" :name="$t('ticketForm.prioritySubject.name')" v-slot="{ errors }">
                    <v-select :error-messages="errors"
                              :label="$t('ticketForm.prioritySubject.label')"
                              :placeholder="$t('ticketForm.prioritySubject.placeholder')"
                              dense
                              :items="$t('ticketForm.priority')"
                              v-model="form.priority">
                    </v-select>
                  </validation-provider>
                </v-col>
                <v-col cols="12" class="pl-0 pr-0">
                  <validation-provider rules="required"
                                       :name="$t('ticketForm.requestQuestion.subjectName')"
                                       v-slot="{ errors }">
                    <v-text-field dense
                                  :error-messages="errors"
                                  v-model="form.subject"
                                  :label="$t('ticketForm.requestQuestion.subjectLabel')"
                                  :placeholder="$t('ticketForm.requestQuestion.subjectPlaceholder')"></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="4" class="pl-0">
                  <validation-provider rules="required"
                                       :name="$t('ticketForm.requestQuestion.scrum.first.name')"
                                       v-slot="{ errors }">
                    <v-textarea dense
                                v-model="scrum.first"
                                :error-messages="errors"
                                auto-grow
                                :label="$t('ticketForm.requestQuestion.scrum.first.label')"
                                :placeholder="$t('ticketForm.requestQuestion.scrum.first.placeholder')"></v-textarea>
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="4" class="pl-0">
                  <validation-provider rules="required"
                                       :name="$t('ticketForm.requestQuestion.scrum.second.name')"
                                       v-slot="{ errors }">
                    <v-textarea dense
                                v-model="scrum.second"
                                :error-messages="errors"
                                auto-grow
                                :label="$t('ticketForm.requestQuestion.scrum.second.label')"
                                :placeholder="$t('ticketForm.requestQuestion.scrum.second.placeholder')"></v-textarea>
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="4" class="pl-0 pr-0">
                  <validation-provider rules="required"
                                       :name="$t('ticketForm.requestQuestion.scrum.third.name')"
                                       v-slot="{ errors }">
                    <v-textarea dense
                                v-model="scrum.third"
                                :error-messages="errors"
                                auto-grow
                                :label="$t('ticketForm.requestQuestion.scrum.third.label')"
                                :placeholder="$t('ticketForm.requestQuestion.scrum.third.placeholder')"></v-textarea>
                  </validation-provider>
                </v-col>
                <v-col cols="12" class="pl-0 pr-0">
                  <p class="font-weight-bold mb-0 mt-n4">{{ $t('ticketForm.requestQuestion.example.title') }}</p>
                </v-col>
                <v-col cols="12" class="pl-0 pr-0 mt-n6">
                  <p class="px-0 mb-0">
                    <small v-html="$t('ticketForm.requestQuestion.example.first')"></small>
                  </p>
                  <p class="px-0 mb-0">
                    <small v-html="$t('ticketForm.requestQuestion.example.second')"></small>
                  </p>
                  <p class="px-0 mb-0">
                    <small v-html="$t('ticketForm.requestQuestion.example.third')"></small>
                  </p>
                </v-col>
                <v-col cols="12" class="pl-0 pr-0">
                  <label>{{ $t('ticketForm.files.label') }}</label>
                  <validation-provider name="Вложения" rules="max_files:5" v-slot="{ errors }">
                    <v-file-input dense
                                  v-model="form.attachments"
                                  @change="chooseFiles"
                                  @click:clear="deleteAttachments"
                                  accept=".xlsx,.xls,image/*,.mp4,.mpeg,.mov,.doc,.docx,.ppt,.pptx,.txt,.pdf"
                                  multiple
                                  show-size
                                  small-chips
                                  :error-messages="errors"
                                  prepend-icon=""
                                  :placeholder="$t('ticketForm.files.placeholder')">
                      <template v-slot:prepend-inner>
                        <v-icon class="mt-2" size="20">mdi-plus</v-icon>
                      </template>
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                            @click:close="deleteAttachment(index)"
                            v-if="index < 2"
                            color="primary accent-4"
                            dark
                            label
                            small
                            close
                        >
                          {{ text }}
                        </v-chip>

                        <span
                            v-else-if="index === 2"
                            class="overline grey--text text--darken-3 mx-2"
                        >
                        +{{ form.attachments.length - 2 }} {{ $tc('ticketForm.files.count', form.attachments.length - 2) }}
                      </span>
                      </template>
                    </v-file-input>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn outlined tile color="primary" type="button">{{ $t('ticketForm.buttons.cancel') }}</v-btn>
              <v-btn :loading="loading"
                     tile color="primary" type="submit">{{ $t('ticketForm.buttons.submit') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </validation-observer>
    </v-col>
    <template v-if="!$vuetify.breakpoint.mobile && !$store.getters.GET_USER.role.includes('admin')">
      <v-col cols="12" lg="6"
             class="d-flex justify-center align-center fill-height">
        <v-img contain max-width="50%" src="@/assets/logo_circle.png"></v-img>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import UploadService from "@/plugins/upload.service"
export default {
  name: "Ticket",
  data () {
    return {
      scrum: {
        first: null,
        second: null,
        third: null
      },
      form: {
        priority: null,
        question: null,
        subject: null,
        type: null,
        attachments: [],
        file: []
      },
      progress: 0
    }
  },
  methods: {
    chooseFiles(files) {
      files.forEach(file => {
          this.form.file.push(file)
      })
    },
    deleteAttachment(index) {
      this.form.attachments.splice(index, 1)
      this.form.file.splice(index, 1)
    },
    deleteAttachments() {
      this.form.attachments = []
      this.form.file = []
    },
    submit () {
      this.$store.dispatch('setLoading', true)
      this.form.question = `${this.$t('ticketForm.requestQuestion.scrum.first.label')}: ${this.scrum.first} | ${this.$t('ticketForm.requestQuestion.scrum.second.label')}: ${this.scrum.second} | ${this.$t('ticketForm.requestQuestion.scrum.third.label')}: ${this.scrum.third}`
      UploadService.upload(this.form,'api/v2/auth/tickets',(event) => {
        this.progress = Math.round((100 * event.loaded) / event.total)
      })
          .then(() => {
            this.form = this.$worker.resetForm(this.form)
            this.$refs.observer.reset()
          })
          .finally(() => {
            this.$store.dispatch('setLoading', false)
          })
    }
  },
  computed: {
    loading () {
      return this.$store.getters.GET_LOADING
    }
  }
}
</script>

<style scoped>

</style>
